import { css } from 'styled-components';
import { COLOR_BLACK } from './colors';
import { TooltipCss } from '../../components/ui/tooltip/tooltip.styled.js';
import { BP_MOBILE_MAX } from './breakpoints';

export default css`
  @import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,600,700&display=swap');

  html {
    font-family: 'Source Sans Pro', sans-serif;
    box-sizing: border-box;
    @media (max-width: ${BP_MOBILE_MAX}px) {
      overflow-x: hidden;
    }
  }
  body {
    font-family: 'Source Sans Pro', sans-serif;
    color: ${COLOR_BLACK};
    box-sizing: border-box;
    @media (max-width: ${BP_MOBILE_MAX}px) {
      overflow-x: hidden;
    }

    &.modal-open {
      overflow: hidden;
    }
  }
  *, *:before, *:after {
    box-sizing: inherit;
  }
  button,
  input {
    font-family: 'Source Sans Pro', sans-serif;
    font: unset;
  }
  a,
  button {
    &:active,
    &:focus {
      text-decoration: none;
      outline: none;
      box-shadow: none;
    }
  }
  time {
    text-transform: capitalize;
  }

  ${TooltipCss}
`;
